export default __webpack_public_path__ + "static/media/btn-zeroback-start-at_de@2x.05d84939.png";